import List from 'containers/Industries/List';
import Edit from 'containers/Industries/Edit';
import Create from 'containers/Industries/Create';
import Show from 'containers/Industries/Show';

export default { List, Edit, Create, Show };
